import axios from 'axios';
import Cookies from "universal-cookie";

function getToken() {
  const cookies = new Cookies();
  return cookies.get("token");
}

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getAuthHeaders = () => ({
  headers: { authorization: `Bearer ${getToken()}` }
});

// Saved Articles API Functions

export function getSavedArticles(teamUuid, projectId, page = 1, perPage = 20) {
  let url = `${API_BASE_URL}/saved-articles?page=${page}&per_page=${perPage}`;
  if (teamUuid) url += `&team_uuid=${teamUuid}`;
  if (projectId) url += `&project_id=${projectId}`;
  return axios.get(url, getAuthHeaders());
}

export function getSavedArticle(articleId) {
  const url = `${API_BASE_URL}/saved-articles/${articleId}`;
  return axios.get(url, getAuthHeaders());
}

export function updateSavedArticle(articleId, articleData) {
  const url = `${API_BASE_URL}/saved-articles/${articleId}`;
  return axios.put(url, articleData, getAuthHeaders());
}

export function deleteSavedArticle(articleId) {
  const url = `${API_BASE_URL}/saved-articles/${articleId}`;
  return axios.delete(url, getAuthHeaders());
}

export function createSavedArticle(articleData) {
  const url = `${API_BASE_URL}/saved-articles`;
  return axios.post(url, articleData, getAuthHeaders());
}

export function createManualArticle(articleData) {
  const url = `${API_BASE_URL}/saved-articles`;
  return axios.post(url, {
    ...articleData,
    source: 'manual'
  }, getAuthHeaders());
}

// Article Search API Functions

export function startArticleSearch(searchData) {
  const url = `${API_BASE_URL}/article-search`;
  return axios.post(url, searchData, getAuthHeaders());
}

export function getSearchStatus(searchRequestId) {
  const url = `${API_BASE_URL}/article-search/${searchRequestId}/status`;
  return axios.get(url, getAuthHeaders());
}

export function getSearchResults(searchRequestId) {
  const url = `${API_BASE_URL}/article-search/${searchRequestId}/results`;
  return axios.get(url, getAuthHeaders());
}

export function getSearchHistory(teamUuid, status = null, page = 1) {
  let url = `${API_BASE_URL}/article-search/history?page=${page}`;
  if (teamUuid) url += `&team_uuid=${teamUuid}`;
  if (status) url += `&status=${status}`;
  return axios.get(url, getAuthHeaders());
}

export function getSearchResult(resultId) {
  const url = `${API_BASE_URL}/article-search/result/${resultId}`;
  return axios.get(url, getAuthHeaders());
}

export function deleteSearchRequest(searchRequestId) {
  const url = `${API_BASE_URL}/article-search/${searchRequestId}`;
  return axios.delete(url, getAuthHeaders());
}

export function saveArticleFromSearch(searchResultData) {
  const url = `${API_BASE_URL}/saved-articles/save-from-search`;
  return axios.post(url, searchResultData, getAuthHeaders());
}